import { render, staticRenderFns } from "./popupsList.vue?vue&type=template&id=474dedb8&"
import script from "./popupsList.vue?vue&type=script&lang=js&"
export * from "./popupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports